import { Box, Modal } from "@mui/material";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { FC, useContext, useEffect, useState } from "react";
import { useRef } from "react";
import {
  sendDigiatlBillViaEmail,
  sendDigiatlBillViaWA,
  sendDigitalBillViaSMS,
} from "../../../redux/slices";
import { useDispatch } from "react-redux";
import { validateEmail, isValidPhoneNumber } from "../../../utils";
import "./style.scss";
import {
  getErrorMessage,
  pos_errormap_without_label,
} from "../../../helpers/errors-helper";
import { SENT_DIGITAL_BILL } from "../../../data/constants";
import React from "react";
import { toastError, toastSuccess } from "../../../utils/react-toaster";

interface Props {
  handleClose: any;
  data: any;
}

const SendDigitalBill: FC<Props> = (props: Props) => {
  const [channel, setChannel] = useState<boolean>(false);
  const [selectedChannel, setSelectedChannel] = useState<string>(
    SENT_DIGITAL_BILL.WHATSAPP
  );
  const [selectedContactNumber, setSelectedContactNumber] =
    useState<string>("");
  const [emailErr, setEmailErr] = useState<any>({});
  const [numberError, setNumberError] = useState<boolean>(false);
  const [isSendClicked, setIsSendClicked] = useState<boolean>(false);
  const ref = useRef<any>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.data?.[0]?.customerInfo && !selectedContactNumber) {
      let num = props.data[0]?.customerInfo?.contactInfo?.phoneNumber || "";
      setSelectedContactNumber(num);
    }
  }, []);

  useEffect(() => {
    if (
      selectedChannel === SENT_DIGITAL_BILL.SMS ||
      selectedChannel === SENT_DIGITAL_BILL.WHATSAPP
    ) {
      handleNumberValidations();
    }
    if (selectedChannel === SENT_DIGITAL_BILL.EMAIL) {
      handleEmailValidations();
    }
  }, [selectedContactNumber]);

  function handleEmailValidations() {
    if (!validateEmail(selectedContactNumber)) {
      setEmailErr(() => true);
    }
  }

  function handleNumberValidations() {
    if (!selectedContactNumber) {
      setNumberError(() => true);
    } else {
      if (selectedContactNumber && !isValidPhoneNumber(selectedContactNumber)) {
        setNumberError(() => true);
      } else {
        setNumberError(() => false);
      }
    }
  }

  function handleSendBill() {
    const callback = function (response: any = {}) { 
      if (response?.sent || response==true) {
        toastSuccess(
          getErrorMessage(
            pos_errormap_without_label,
            `SENT_DIGITAL_BILL`,
            selectedChannel,
            selectedContactNumber
          )
        );
        props.handleClose(false);
      } else if (response?.code) {
        toastError(response?.code);
      } else {
        toastError(
          getErrorMessage(
            pos_errormap_without_label,
            "GENERAL_OPERATION_FAILED_MSG",
            ""
          )
        );
      }
    };
    let mid = props?.data?.mid,
      businessName = props.data?.billHeader?.businessName || "";
    if (selectedChannel === SENT_DIGITAL_BILL.EMAIL && !emailErr) {
      dispatch(
        sendDigiatlBillViaEmail({ mid, selectedContactNumber, callback })
      );
    } else if (selectedChannel === SENT_DIGITAL_BILL.SMS) {
      let payload = {
        amount: "INR " + props.data?.billTotal,
        mobileNumber: parseInt(selectedContactNumber),
        isExternal: true,
        type: null,
        hasSMSProvider: true,
        businessName,
      };

      if (!numberError) {
        dispatch(sendDigitalBillViaSMS({ mid, payload, callback }));
      }
    } else if (selectedChannel === SENT_DIGITAL_BILL.WHATSAPP) {
      let payload = {
        businessName,
        isExternal: true,
        mobileNumber: parseInt(selectedContactNumber),
        type: null,
      };
      if (!numberError) {
        dispatch(sendDigiatlBillViaWA({ mid, payload, callback }));
      }
    }
  }

  const handleWAChange = (val: any) => {
    setNumberError(() => false);
    setIsSendClicked(false);
    setSelectedContactNumber(val);
  };

  const handleChannelSelection = (e: any, type: string) => {
    e.stopPropagation();
    if (type === SENT_DIGITAL_BILL.EMAIL) {
      let email = props.data[0]?.customerInfo?.contactInfo?.email || "";
      setSelectedContactNumber(email);
    } else {
      let num =
        props.data[0]?.customerInfo?.contactInfo?.phoneNumber ||
        selectedContactNumber ||
        "";
      setSelectedContactNumber(num);
    }
    setSelectedChannel(type);
    setChannel(false);
  };
  function renderSelectedChannel(selectedChannel: any){
    switch (selectedChannel) {
      case SENT_DIGITAL_BILL.WHATSAPP:
        return (
          <div className="w-[90%] sm:w-full mt-[8%]">
            <div className="text-[14px] text-[#333333DE]">Enter WhatsApp Number</div>
            <div className="border-[1px] border-[#707070] w-full rounded-[8px] h-[3rem] mt-5 flex items-center hover:border-blue-500">
              <div className="pos-icons-mb whatsApp-icon ml-3"></div>
              <input
                onChange={(e: any) =>
                  handleWAChange(e.target.value.replace(/[^0-9 . -]/g, ""))
                }
                value={selectedContactNumber}
                className="border-none pl-[1rem] h-[2.8rem] rounded-[8px] w-full outline-none"
                placeholder="Enter Whatsapp Number"
              />
            </div>
          </div>
        );
    
      case SENT_DIGITAL_BILL.SMS:
        return (
          <div className="w-[90%] sm:w-full mt-[8%]">
            <div className="text-[14px] text-[#333333DE]">Enter Number</div>
            {numberError && isSendClicked && (
              <div className="text-red-500 text-[12px]">Enter valid number</div>
            )}
            <div className="border-[1px] border-[#707070] w-full rounded-[8px] h-[3rem] mt-5 flex items-center hover:border-blue-500">
              <div className="pos-icons-mb sms-icon ml-3"></div>
              <input
                onChange={(e: any) => {
                  setNumberError(() => false);
                  setIsSendClicked(false);
                  setSelectedContactNumber(e.target.value);
                }}
                value={selectedContactNumber}
                className="border-none pl-[1rem] h-[2.8rem] rounded-[8px] w-full outline-none"
                placeholder="Enter Number"
              />
            </div>
          </div>
        );
    
      case SENT_DIGITAL_BILL.EMAIL:
        return (
          <div className="w-[90%] sm:w-full mt-[8%]">
            <div className="text-[14px] text-[#333333DE]">Enter Email</div>
            {emailErr && isSendClicked && (
              <div className="text-red-500 text-[12px]">Enter valid email</div>
            )}
            <div className="border-[1px] border-[#707070] w-full rounded-[8px] h-[3rem] mt-5 flex items-center hover:border-blue-500">
              <div className="pos-icons-mb email-icon ml-3"></div>
              <input
                onChange={(e: any) => {
                  setEmailErr(() => false);
                  setIsSendClicked(false);
                  setSelectedContactNumber(e.target.value);
                }}
                value={selectedContactNumber}
                className="border-none pl-[1rem] h-[2.8rem] rounded-[8px] w-full outline-none"
                placeholder="Enter Email"
              />
            </div>
          </div>
        );
    }
    
  }
  return (
    <Modal
      className="flex justify-center items-center smd:justify-end smd:items-end"
      open={true}
      onClose={() => props.handleClose(false)}
    >
      <Box
        style={{ outline: 0 }}
        className="w-[40%] sm:w-[100%] relative flex flex-col  items-center  bg-white rounded-[12px] border-none shadow-[0px_3px_6px_#00000029] modal-bottom sm:px-16"
      >
        <div className="flex justify-between w-[90%] items-center mt-[5%] sm:flex-col sm:mr-auto">
          <div className="text-[24px] font-[600]">Send Digital Bill</div>
          <div className="flex justify-around items-center sm:flex-col sm:mr-auto sm:mt-[10%]">
            <div className="text-[#333333DE] text-[14px] mr-3 sm:mr-auto ">
              Send On
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setChannel(true);
              }}
              className="border rounded-[8px] text-[14px] font-[500] px-3 relative text-[#397EF5] h-[48px] flex justify-around items-center"
            >
              {selectedChannel}{" "}
              <ArrowDropDownRoundedIcon className="text-[#397EF5]" />
              {channel && (
                <div
                  ref={ref}
                  className="rounded-[8px] shadow-[0px_3px_6px_#00000029] w-[80px] top-2 absolute bg-white text-black"
                >
                  <div
                    onClick={(e) => handleChannelSelection(e, "WhatsApp")}
                    className="h-[2.3rem] pt-7 hover:bg-[#EBEBEB]"
                  >
                    WhatsApp
                  </div>
                  <div
                    onClick={(e) => handleChannelSelection(e, "SMS")}
                    className="h-[2.3rem] pt-3 hover:bg-[#EBEBEB]"
                  >
                    SMS
                  </div>
                  <div
                    onClick={(e) => handleChannelSelection(e, "Email")}
                    className="h-[2.3rem] pt-3 mb-5 hover:bg-[#EBEBEB]"
                  >
                    Email
                  </div>
                </div>
              )}
            </button>
          </div>
        </div>
        {renderSelectedChannel(selectedChannel)}
 

        <div className="mt-[10%] mb-[5%] w-[90%] sm:w-full flex justify-end items-center font-[600] sm:justify-between">
          <button
            onClick={() => props.handleClose(false)}
            className="border h-[2.5rem] rounded-[8px] mr-[16px] w-[100px] sm:hidden text-[15px] hover:border-blue-500"
          >
            Back
          </button>
          <button
            onClick={() => {
              setIsSendClicked(true);
              handleSendBill();
            }}
            className={`${
              !selectedContactNumber
                ? "opacity-[0.4] pointer-events-none"
                : "hover:opacity-70"
            } border h-[2.5rem] rounded-[8px] text-white w-[100px] bg-[#397EF5] sm:w-full text-[15px]`}
          >
            Send Bill
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default SendDigitalBill;
